import N8nCanvasCollaborationPill from './CanvasCollaborationPill.vue';

export default N8nCanvasCollaborationPill;
